import FormDrawer from "components/__new/common/form-drawer";
import successGif from "assets/images/icons/success-green-2.gif";
import Maybe from "components/__new/common/Maybe";
import { ButtonLoader, Input } from "components/__new/common/form";
import CustomSwitch from "./form/CustomSwitch";

/**
button1={{
    "text": "",
    "class": "",
    "click": "",
}}
*/

export const ModalAlert = (props) => {
    const {
        isOpenModalAlert,
        messageType,
        setIsOpenModalAlert,
        subText,
        closeDialog,
        showSwitch,
        isSwitchActive,
        onSwitchChange,
        hideSwitchLabel,
        switchTitle,
        switchSubtitle,
        onModalClose,
        showInputField,
        inputFieldLabel,
        inputFieldPlaceholder,
        inputFieldButtonText,
        onInputFieldChange,
        inputFieldOnSubmit,
        inputFieldValue
    } = props;
    const {button1, button2, button3} = props;

    const successImg = props.successImg || successGif;
    const successText = props.successText || "Successful";
    const dismissText = props.dismissText || "Dismiss";

    const dismiss = () => {
        if (props.submit !== undefined){
            props.submit();
        }
        else{
            setIsOpenModalAlert(false)
            onModalClose && onModalClose()
        }
    }

    return (
        <FormDrawer display="center" size="sm" isOpen={isOpenModalAlert} setIsOpen={setIsOpenModalAlert} closeDialog={closeDialog}>
            <div className="p-6 max-w-sm">
                <div className="w-32 h-32 mx-auto flex items-center justify-center">
                    <img src={successImg} alt="Success" className="object-contain" />
                </div>
                <div className="mt-0 text-lg text-center text-[#374151]">
                    {successText}
                </div>
                <Maybe condition={subText !== undefined}>
                    <div className="mt-2 text-fade text-center">
                        {subText}
                    </div>
                </Maybe>
                
                {messageType === "transfer" ? (
                    <Maybe condition={showSwitch === true}>
                        <div className="w-full flex items-center justify-between my-7">
                            <div className="text-sm mb-px flex flex-col">
                                {switchTitle}
                                <span className="text-xs text-[#667085]">
                                    {switchSubtitle}
                                </span>
                            </div>
                        <CustomSwitch
                            onChange={onSwitchChange}
                            active={isSwitchActive}
                            hideSwitchLabel={hideSwitchLabel}
                          />
                      </div>
                  </Maybe>
                ) : 
                (
                    <Maybe condition={showSwitch === true}>
                    <div className="w-full flex items-center justify-between my-7">
                        <div className="text-sm mb-px flex flex-col">
                            {switchTitle}
                            <span className="text-xs text-[#667085]">
                                {switchSubtitle}
                            </span>
                        </div>

                        <CustomSwitch
                            onChange={onSwitchChange}
                            active={isSwitchActive}
                            hideSwitchLabel={hideSwitchLabel}
                        />
                    </div>
                </Maybe>
                ) 
                }
                <Maybe condition={showInputField}>
                    <div className="w-full relative my-7">
                        <Input
                            className="w-full"
                            type="text"
                            label={inputFieldLabel}
                            placeholder={inputFieldPlaceholder}
                            rightIcon={
                                <button className="text-ep-primary-600 text-sm">
                                    {inputFieldButtonText}
                                </button>
                            }
                            rightIconClass="pr-2"
                            onChange={onInputFieldChange}
                            rightIconClicked={inputFieldOnSubmit}
                            value={inputFieldValue}
                        />
                    </div>
                </Maybe>
                
                <div className="mt-6">
                    <Maybe condition={button1 !== undefined}>
                        <ButtonLoader type="button" loading={button1?.loading || false} onClick={button1?.click} className={button1?.class + " mb-2"}>
                            {button1?.text}
                        </ButtonLoader>
                    </Maybe>

                    <Maybe condition={button2 !== undefined}>
                        <ButtonLoader type="button" loading={button2?.loading || false} onClick={button2?.click} className={button2?.class + " mb-2"}>
                            {button2?.text}
                        </ButtonLoader>
                    </Maybe>

                    <Maybe condition={button3 !== undefined}>
                        <ButtonLoader type="button" loading={button3?.loading || false} onClick={button3?.click} className={button3?.class + " mb-2"}>
                            {button3?.text}
                        </ButtonLoader>
                    </Maybe>

                    <Maybe condition={props.dismissText !== undefined && props.dismissText !== null}>
                        <button type="button" onClick={dismiss} className="btn btn-block btn-ep-primary">
                            {dismissText}
                        </button>
                    </Maybe>
                </div>
            </div>
        </FormDrawer>
    )
}

export default ModalAlert;
